import { createSlice } from "@reduxjs/toolkit";

import { cloneBookingAPI } from "../../api/cloneBooking";
import { sliceHandler } from "./utils";

const cloneBookingSlice = createSlice(
  sliceHandler({
    name: 'cloneBooking',
    action: 'cloneBookingSlice',
    success: 'cloneBookingSliceSuccess',
    failure: 'cloneBookingSliceFailure',
    reset: 'cloneBookingSliceReset',
  })
);

const cloneBookingAction: any = cloneBookingSlice.actions;

const cloneBookingHandler = (data: any) => async (dispatch: any) => {
  try {
    dispatch(cloneBookingAction.cloneBookingSlice());
    const res: any = await cloneBookingAPI(data);
    dispatch(cloneBookingAction.cloneBookingSliceSuccess(res));
  } catch (e: any) {
    dispatch(cloneBookingAction.cloneBookingSliceFailure(e?.response?.data));
  }
};

export default cloneBookingSlice.reducer;

export {
  cloneBookingAction,
  cloneBookingHandler,
}